module.exports = __webpack_public_path__ + "img/s6.a69abead.svg";